import { FC, useCallback, useState } from 'react';

import CheckIcon from '../assets/li_check.svg';
import { useTranslations } from '../hooks/useTranslations.ts';
import { translationKeys } from '../translations/translationKeys.ts';
import { returnToCustomerHub } from '../utils/navigation.ts';
import { BaseScreen } from './BaseScreen';

type ThankYouScreenSumsubProps = {
  sumsubUrl: string;
  embedded: boolean;
  region?: string;
};

const AUSTRIA_SUMSUB_URL =
  import.meta.env.VITE_CUSTOM_ENV === 'prod'
    ? 'https://in.sumsub.com/websdk/p/uni_q9G5mhqYxS97eESf'
    : 'https://in.sumsub.com/websdk/p/sbx_uni_CrdR4BFZHtd0pugF';

const ThankYouScreenSumsub: FC<ThankYouScreenSumsubProps> = ({ sumsubUrl, region, embedded }) => {
  const [sumsubHasLaunchedAlready, setSumsubHasLaunchedAlready] = useState(false);
  const { translate } = useTranslations();
  const isGermany = region?.toUpperCase() === 'DE';
  const isAustria = region?.toUpperCase() === 'AT';

  const resolvedSumsubUrl = isAustria ? AUSTRIA_SUMSUB_URL : sumsubUrl;

  const handleContinue = useCallback(() => {
    if (isGermany) {
      returnToCustomerHub(embedded);
      return;
    }

    if (embedded) {
      if (sumsubHasLaunchedAlready) {
        returnToCustomerHub(embedded);
        return;
      }

      setSumsubHasLaunchedAlready(true);

      window.parent.postMessage(JSON.stringify({ type: 'launchExternalUrl', url: resolvedSumsubUrl }), '*');
    } else {
      window.location.href = resolvedSumsubUrl;
    }
  }, [resolvedSumsubUrl, embedded, sumsubHasLaunchedAlready, isGermany]);

  return (
    <BaseScreen
      formTitle={translate(translationKeys.THANK_YOU_APPLICATION_RECEIVED_TITLE)}
      formSubtitle=""
      headerIcon={CheckIcon}
      footerBtnLabel={
        isGermany || sumsubHasLaunchedAlready
          ? translate(translationKeys.THANK_YOU_BUTTON_CLOSE)
          : translate(translationKeys.FOOTER_BUTTON_LABEL)
      }
      footerBtnOnClick={handleContinue}
      footerBtnLoading={false}
      footerBtnDisabled={false}
    >
      <div className="w-full mb-6">
        <p className="text-base leading-6 text-content-secondary">{translate(translationKeys.THANK_YOU_SUMSUB_BODY)}</p>
      </div>
    </BaseScreen>
  );
};

export default ThankYouScreenSumsub;
